import styled from "styled-components";

export const NoDataMessage = styled.div`
  display: flex;
  font-size: 1.2em;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;